import React, {Component} from 'react';
import {Router, Route, Switch} from 'react-router';
import CombinedContainers from './Container/CombinedContainers';
import history from './history';

class Routes extends Component {

    render() {
        var date = Date.now()
        var url = window.location.href
        return(
            <div>
                <Router history={history}>
                    <div>
                        <Switch>
                         <Route exact path="/" component={CombinedContainers}/>
                         <Route exact path="/:id" component={CombinedContainers} />
                         {/* <Route exact path="/:id/g" component={() => { window.location.href = url + date;return null; }}/>
                         <Route exact path="/:id/t" component={() => { window.location.href = url + date;return null; }}/>
                         <Route exact path="/:id/s" component={() => { window.location.href = url + date;return null; }}/>
                         <Route exact path="/:id/e" component={() => { window.location.href = url + date;return null; }}/> */}
                         <Route exact path="/:id/:slug" component={CombinedContainers} />
                        </Switch>
                    </div>
                </Router>
            </div>
        )

    }
}
export default Routes;
